import { MenuService } from '../services/menu-service';

export class MenuController {
  static readonly getMenu = async () => {
    return await MenuService.getMenu();
  };

  static readonly getMenuCategories = async () => {
    return await MenuService.getCategories();
  };
}
